import { store } from "../Store/Store";

export var isDev = false;
const initState = store.getState();

isDev = initState?.authData?.isDev || false;

store.subscribe(() => {
  const state = store.getState();
  const newIsDev = state?.authData?.isDev || false;
  if (isDev != newIsDev) {
    isDev = newIsDev;
  }
});

export const log = {
  error: (...args) => {
    if (isDev) console.error(...args);
  },
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  info: (...args) => {
    if (isDev) console.info(...args);
  },
  debug: (...args) => {
    if (isDev) console.debug(...args);
  },
};
